// ── HERO (static — no slideshow) ──

// ── QUOTE ROTATOR ──
(function() {
  const qs   = document.querySelectorAll('.lc-quote');
  const dots = document.querySelectorAll('.lc-qdot');
  if (!qs.length) return;
  let cur = 0, timer;
  function go(n) {
    qs[cur].classList.remove('active');
    dots[cur].classList.remove('active');
    cur = (n + qs.length) % qs.length;
    qs[cur].classList.add('active');
    dots[cur].classList.add('active');
  }
  dots.forEach((d,i) => d.addEventListener('click', () => { go(i); clearInterval(timer); timer = setInterval(() => go(cur+1), 4500); }));
  timer = setInterval(() => go(cur + 1), 4500);
})();

// ── MOBILE MENU ──
(function() {
  const btn = document.getElementById('mobileMenuBtn');
  const nav = document.getElementById('mobileNav');
  if (!btn) return;
  btn.addEventListener('click', () => nav.classList.toggle('open'));
})();

// ── STICKY HEADER SHADOW ──
(function() {
  const hdr = document.getElementById('site-header');
  if (!hdr) return;
  window.addEventListener('scroll', () => {
    hdr.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
})();

// ── SMOOTH SCROLL FOR /#science etc ──
document.querySelectorAll('a[href*="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const url = new URL(a.href, location.href);
    if (url.pathname === location.pathname && url.hash) {
      const target = document.querySelector(url.hash);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
});
